<template src="../templates/symulator.html"></template>
<style lang="scss" src="../styles/_symulator.scss"></style>

<script>

import WeatherTools from "./WeatherTools";
import Weather from './Weather';
import MessageBox from './MessageBox';
import Home from './Home';
import Dashboard from './Dashboard';
import PowerStationSvg from '@/assets/icon/power-station.svg';

export default {
  name: 'Symulator',
  data(){
    return {
      dashboard: {
        production: 1,
        using: 0,
        bilans: 0,
        powerStation: false,
      },

      loader: {
        color: 'uncharge',
        speed: {
          solarDashboard: 0,
          dashboardPowerstation: 0,
          dashboardHome: 0,
          powerstationHome: 0,
        }
      },

      weather: 3,
      usingPower: 4270,

      message: {
        icon: 'auto',
        title: 'Lorem',
        content: 'ipsum'
      },
      config: {
        home: [
          { slug: 'lamp', name: "Lampka", power: 30, active: true },
          { slug: 'tv', name: "Telewizor", power: 340, active: true },
          { slug: 'fridge', name: "Lodówka", power: 400, active: true },
          { slug: 'wm', name: "Pralka", power: 1000, active: true },
          { slug: 'owen', name: "Piekarnik", power: 2500, active: true },
        ],
        weathers: [
          { power: 0 },
          { power: 1000 },
          { power: 3500 },
          { power: 5000 }
        ],
        messages: {
          night: {
            title: "Instalacja nie produkuje prądu.",
            content: "Urządzenia domowe zasilane są całkowicie z wcześniej zmagazynowanego prądu (np. w ciągu słonecznego dnia) u dostawcy energii.",
          },
          greater: {
            title: "Instalacja produkuje więcej prądu niż potrzebuje dom.",
            content: "Urządzenia domowe zasilane są całkowicie z prądu z instalacji, a nadwyżka jest magazynowana u dostawcy energii. ",
          },
          equal: {
            title: "Instalacja produkuje tyle prądu ile potrzebuje dom.",
            content: "Urządzenia domowe zasilane są całkowicie z prądu z instalacji."
          },
          less: {
            title: "Instalacja produkuje mniej prądu niż potrzebuje dom.",
            content: "Urządzenia domowe zasilane są częściowo z prądu z instalacji, a częściowo z wcześniej zmagazynowanego prądu u dostawcy energii."
          }
        }
      }
    }
  },
  components:{
    WeatherTools,
    Weather,
    MessageBox,
    Home,
    Dashboard,
    PowerStationSvg
  },
  props: {
    msg: String
  },
  computed: {
    inputPower: function(){ return this.config.weathers[this.weather].power; }
  },
  mounted(){
    this.update();
    this.runtime()
  },
  methods: {
    update(){
      this.dashboard.production = this.inputPower / 5000;
      this.dashboard.using = this.usingPower / 5000;
      this.loader.speed.solarDashboard = this.inputPower / 5000;
      this.loader.speed.dashboardHome = Math.min(this.inputPower, this.usingPower) / 5000;
      this.loader.speed.dashboardPowerstation = (this.inputPower - this.usingPower) / 5000;
      this.loader.speed.powerstationHome = (this.usingPower - this.inputPower) / 5000;
      this.dashboard.powerStation = this.usingPower > this.inputPower;

      if(this.inputPower >= this.usingPower){
        this.message.icon = 'charge';
      }else{
        if(this.dashboard.bilans >= 0){
          this.message.icon = 'auto';
        }else{
          this.message.icon = 'uncharge';
        }
      }
      if(this.inputPower > 0){
        this.loader.color = 'charge';
      }else{
        if(this.dashboard.bilans >= 0){
          this.loader.color = 'auto';
        }else{
          this.loader.color = 'uncharge';
        }
      }
      if(this.weather > 0){
        if(this.inputPower > this.usingPower){
          this.message.title = this.config.messages.greater.title;
          this.message.content = this.config.messages.greater.content;
        }
        else if(this.inputPower < this.usingPower){
          this.message.title = this.config.messages.less.title;
          this.message.content = this.config.messages.less.content;
        }
        else{
          this.message.title = this.config.messages.equal.title;
          this.message.content = this.config.messages.equal.content;
        }
      }else{
        this.message.title = this.config.messages.night.title;
        this.message.content = this.config.messages.night.content;
      }

    },
    calcDuration(speed){
      return ((1-speed) * 500 + 150) + 'ms';
    },
    onChangeWeather(event){
      this.weather = event;
      this.update();
    },
    onUsingPower(event){
      this.usingPower = event;
      this.update();
    },
    runtime(){
      this.update();
      let mul = (this.inputPower >= this.usingPower ? 0.8 : 1);
      this.dashboard.bilans += (this.inputPower - this.usingPower)*0.001 * mul;
      const self = this;
      setTimeout(function (){
        self.runtime();
      }, 1000);
    }
  }
}
</script>

